import {
  types,
  ICreateDatafileAction,
  ICreateDatafileSuccessAction,
  IGetDataFileAction,
  IGetDataFileSuccessAction,
  IFailureAction,
  IUpdateDatafileAction,
  IUpdateDatafileSuccessAction,
  IDataStream,
  DataStreamForPreviewType,
  IGetDataFileFailureAction,
  IDataStreamError,
} from '../types/datafile'

export const createDatafile = (
  packId: string,
  datastream: IDataStream
): ICreateDatafileAction => ({
  type: types.CREATE_DATAFILE__STARTED,
  packId,
  datastream,
})

export const createDatafileSuccess = (
  message: string
): ICreateDatafileSuccessAction => ({
  type: types.CREATE_DATAFILE__SUCCESS,
  message,
})

export const createDatafileFailure = (
  message: string,
  correlationId: string
): IFailureAction => ({
  type: types.CREATE_DATAFILE__FAILURE,
  message,
  correlationId,
})

export const getDataFile = (
  datastream: DataStreamForPreviewType
): IGetDataFileAction => ({
  type: types.GET_DATAFILE__STARTED,
  datastream,
})

export const getDataFileSuccess = (
  datastream: DataStreamForPreviewType
): IGetDataFileSuccessAction => ({
  type: types.GET_DATAFILE__SUCCESS,
  datastream,
})

export const getDataFileFailure = (
  dataStreamError: IDataStreamError
): IGetDataFileFailureAction => ({
  type: types.GET_DATAFILE__FAILURE,
  dataStreamError,
})

export const updateDatafile = (
  packId: string,
  editionId: string,
  datastream: IDataStream
): IUpdateDatafileAction => ({
  type: types.UPDATE_DATAFILE__STARTED,
  packId,
  editionId,
  datastream,
})

export const updateDatafileSuccess = (
  message: string
): IUpdateDatafileSuccessAction => ({
  type: types.UPDATE_DATAFILE__SUCCESS,
  message,
})

export const updateDatafileFailure = (
  message,
  correlationId
): IFailureAction => ({
  type: types.UPDATE_DATAFILE__FAILURE,
  message,
  correlationId,
})
